import { Directive, ElementRef } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

/**
 * Generated class for the KeyboardNoAccessoryDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[keyboard-no-accessory]', // Attribute selector
})
export class KeyboardNoAccessoryDirective {
  constructor(public element: ElementRef) {
    if (Capacitor.platform !== 'web') {
      this.element.nativeElement.addEventListener('focus', () => {
        Keyboard.setAccessoryBarVisible({ isVisible: false });
      });
      this.element.nativeElement.addEventListener('touchstart', () => {
        Keyboard.setAccessoryBarVisible({ isVisible: false });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/keyboard-no-accessory/keyboard-no-accessory.ts